<template>
  <form @submit.prevent="gonder">
    <div class="row g-2">
      <div class="col-12">
        <label class="form-label">İş Adı</label>
        <input v-model="localForm.ad" class="form-control" placeholder="Örn: -AY-İSMİ- Rapor Tasarımı" />
      </div>
      <div class="col-12">
        <label class="form-label">Açıklama</label>
        <textarea v-model="localForm.aciklama" class="form-control" rows="3"></textarea>
      </div>
      <div class="col-6">
        <label class="form-label">Periyot</label>
        <select v-model="localForm.periyot" class="form-select">
          <option value="haftalik">Haftalık</option>
          <option value="aylik">Aylık</option>
        </select>
      </div>
      <div class="col-6">
        <label class="form-label">Sonraki Tarih</label>
        <Datepicker
          v-model="localForm.sonraki_tarih"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :enable-time-picker="true"
          placeholder="Sonraki çalışma tarihi"
        />
      </div>
      <div class="col-6">
        <label class="form-label">Durum</label>
        <select v-model="localForm.durum" class="form-select">
          <option value="ajansyeni">Yeni</option>
          <option value="hazirlaniyor">Hazırlanıyor</option>
          <option value="ajansonaybekliyor">Ajans Onayı Bekliyor</option>
          <option value="musterionaybekliyor">Müşteri Onayı Bekliyor</option>
        </select>
      </div>
      <div class="col-6">
        <label class="form-label">Aciliyet</label>
        <select v-model="localForm.aciliyet" class="form-select">
          <option value="0">Beklemede</option>
          <option value="1">Normal</option>
          <option value="2">Acil</option>
          <option value="3">Çok Acil</option>
        </select>
      </div>
      <div class="col-12">
        <label class="form-label">İş Türü</label>
        <v-select-coklu multiple v-model="localForm.istur" :options="isturler" label="ad" :reduce="(item) => item.id" />
      </div>
      <div class="col-12">
        <label class="form-label">Atanacak Kullanıcılar</label>
        <v-select-coklu multiple v-model="localForm.kullanicilar" :options="kullanicilar" label="ad" :reduce="(item) => item.id" />
      </div>
      <div class="col-12">
        <label class="form-check">
          <input type="checkbox" class="form-check-input" v-model="aktifCheck" />
          <span class="form-check-label">Aktif</span>
        </label>
      </div>
    </div>

    <div class="d-flex gap-2 mt-3">
      <button type="button" class="btn btn-outline-primary" @click="formIptal">İptal</button>
      <button type="submit" class="btn btn-primary w-100">Kaydet</button>
    </div>
  </form>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import vSelectCoklu from "@/components/ortak/vSelectCoklu.vue";

export default {
  components: {
    Datepicker,
    vSelectCoklu,
  },
  props: {
    formIslem: String,
    formData: Object,
    musteriId: [String, Number],
    formKaydetSonrasi: Function,
    formIptal: Function,
  },
  data() {
    return {
      isturler: [],
      kullanicilar: [],
      localForm: {
        ad: "",
        aciklama: "",
        periyot: "aylik",
        sonraki_tarih: null,
        durum: "ajansyeni",
        aciliyet: "1",
        istur: [],
        kullanicilar: [],
        aktif: 1,
      },
      aktifCheck: true,
    };
  },
  watch: {
    formData: {
      immediate: true,
      handler(val) {
        const data = val || {};
        this.localForm = {
          ...this.localForm,
          ...data,
          istur: this.parseArray(data.istur),
          kullanicilar: this.parseArray(data.kullanicilar),
          sonraki_tarih: data.sonraki_tarih ? new Date(String(data.sonraki_tarih).replace(" ", "T")) : null,
        };
        this.aktifCheck = String(this.localForm.aktif) !== "0";
      },
    },
  },
  async mounted() {
    const [isturRes, kulRes] = await Promise.all([axiosCustom.get("isturler"), axiosCustom.get("kullanicilar")]);
    this.isturler = isturRes.data || [];
    this.kullanicilar = kulRes.data || [];
  },
  methods: {
    parseArray(val) {
      if (!val) return [];
      if (Array.isArray(val)) return val;
      return String(val)
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);
    },
    formatDateForApi(dateObj) {
      if (!dateObj) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${dateObj.getFullYear()}-${pad(dateObj.getMonth() + 1)}-${pad(dateObj.getDate())} ${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}:${pad(dateObj.getSeconds())}`;
    },
    async gonder() {
      if (!this.localForm.ad || !this.localForm.sonraki_tarih) {
        this.$toast.error("İş adı ve sonraki tarih zorunludur.");
        return;
      }

      const formData = new FormData();
      formData.append("ad", this.localForm.ad);
      formData.append("aciklama", this.localForm.aciklama || "");
      formData.append("periyot", this.localForm.periyot || "aylik");
      formData.append("sonraki_tarih", this.formatDateForApi(this.localForm.sonraki_tarih));
      formData.append("durum", this.localForm.durum || "ajansyeni");
      formData.append("aciliyet", this.localForm.aciliyet || "1");
      formData.append("istur", Array.isArray(this.localForm.istur) ? this.localForm.istur.join(",") : this.localForm.istur || "");
      formData.append("kullanicilar", Array.isArray(this.localForm.kullanicilar) ? this.localForm.kullanicilar.join(",") : this.localForm.kullanicilar || "");
      formData.append("aktif", this.aktifCheck ? "1" : "0");

      try {
        if (this.formIslem === "duzenle") {
          await axiosCustom.post(`musteriler/tekraredenisduzenle/${this.localForm.id}`, formData);
          this.$toast.success("Tekrar eden iş güncellendi");
        } else {
          await axiosCustom.post(`musteriler/tekraredenisekle/${this.musteriId}`, formData);
          this.$toast.success("Tekrar eden iş eklendi");
        }
        this.formKaydetSonrasi();
      } catch (error) {
        this.$toast.error("Kaydetme hatası");
      }
    },
  },
};
</script>
